import styled from 'styled-components';
import AlertEmptyTriangle from '#/shared/components/GeneratedIcons/trimet/AlertEmptyTriangle';

export const AlertsBadgeContainer = styled.div`
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AlertsBadgeIcon = styled(AlertEmptyTriangle).attrs(props => ({
  fill: props.fill || props.theme.normalAlertIconFill,
}))`
  position: absolute;
`;

export const AlertsBadgeText = styled.div.attrs(props => ({
  longText: props.textLength > 1,
}))`
  color: ${props => props.textColor || props.theme.warningFontColor};
  font-size: ${props =>
    // integers below are font size in px when default size is used
    (props.size * (props.longText ? 12 : 15)) / props.defaultSize}px;
  padding-top: ${props => (props.longText ? 40 : 26)}%;
  z-index: 1;
`;
